<template>
    <section>

        <TextOneColumn
            v-if="matrix.section.type == 'textOneColumn'"
            :textContent="matrix.section.textEditor"
        />

        <HeaderText
            v-if="matrix.section.type == 'headerText'"
            :textContent="matrix.section.textEditor"
        />

        <textTwoColumns
            v-if="matrix.section.type == 'textTwoColumns'"
            :textContentLeft="matrix.section.leftColumn"
            :textContentRight="matrix.section.rightColumn"
        />

        <VideoEmbed
            v-if="matrix.section.type == 'videoEmbed'"
            :videoEmbed="matrix.section.videoLink"
        />

        <Quote
            v-if="matrix.section.type == 'quote'"
            :quote="matrix.section.textQuote"
            :quoteFormat="matrix.section.quoteFormat"
        />

        <TextImg
            v-if="matrix.section.type == 'textImg'"
            :sectionTitle="matrix.section.sectionTitle"
            :textEditor="matrix.section.textEditor"
            :position="matrix.section.position.value"
            :img="matrix.section.img"
        />

        <TextHighlight
            v-if="matrix.section.type == 'textHighlight'"
            :textEditor="matrix.section.textEditor"
            :backgroundColor="matrix.section.backgroundColor.value"
            :sectionLink="matrix.section.sectionLink"
            :sectionLinkText="matrix.section.sectionLinkText"
            :sectionLinkType="matrix.section.sectionLinkType"
        />

        <NewsFooter
            v-if="matrix.section.type == 'newsFooter'"
            :textContent="matrix.section.textEditor"
        />

        <ImagesGallery
            v-if="matrix.section.type == 'imagesGallery'"
            :gallery="matrix.section.images"
        />

        <AlternatelySections
            v-if="matrix.section.type == 'alternatelySections'"
            :sectionBlock="matrix.section.sectionBlock"
        />

        <SectionDetailsBlack
            v-if="matrix.section.type == 'sectionDetailsBlack'"
            :sectionBlock="matrix.section"
        />

        <Testimonials_03
            v-if="matrix.section.type == 'testimonials_03'"
            :sectionBlock="matrix.section"
        />
        <SectionAditionalInfos
            v-if="matrix.section.type == 'sectionAditionalInfos'"
            :sectionBlock="matrix.section"
        />

        <SectionCta
            v-if="matrix.section.type == 'sectionCta'"
            :sectionBlock="matrix.section"
        />

        <SwipperTimeline
            v-if="matrix.section.type == 'swipperTimeline'"
            :sectionBlock="matrix.section"
        />

        <CounterSection
            v-if="matrix.section.type == 'counterSection'"
            :sectionBlock="matrix.section"
        />
        <InisStats
            v-if="matrix.section.type == 'inisStats'"
            :sectionBlock="matrix.section"
        />
        <activityReport
            v-if="matrix.section.type == 'activityReport'"
            :sectionBlock="matrix.section"
        />
        <SectionPersonnel
            v-if="matrix.section.type == 'sectionPersonnel'"
            :sectionBlock="matrix.section"
            :indexMatrix="indexMatrix"
        />
        <PartnersLogos
            v-if="matrix.section.type == 'partnersLogos'"
            :sectionBlock="matrix.section"
            :indexMatrix="indexMatrix"
        />
        <AccordionFullWidth
            v-if="matrix.section.type == 'accordionFullWidth'"
            :accordions="matrix.section.accordions"
            :indexMatrix="indexMatrix"
        />
        <ImgFullWidth
            v-if="matrix.section.type == 'imgFullWidth'"
            :img="matrix.section.img"
        />
        <InfoCardWithImage
            v-if="matrix.section.type == 'infoCardWithImage'"
            :el="matrix.section"
        />
        <NewsletterForm
            v-if="matrix.section.type == 'newsletterForm'"
            :el="matrix.section"
        />
    </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import TextOneColumn from '@/components/matrix/textOneColumn'
import HeaderText from '@/components/matrix/headerText'
import TextTwoColumns from '@/components/matrix/textTwoColumns'
import VideoEmbed from '@/components/matrix/videoEmbed'
import Quote from '@/components/matrix/quote'
import TextImg from '@/components/matrix/textImg'
import TextHighlight from '@/components/matrix/textHighlight'
import NewsFooter from '@/components/matrix/newsFooter'
import ImagesGallery from '@/components/matrix/imagesGallery'
import AlternatelySections from '@/components/matrix/alternatelySections'
import SectionDetailsBlack from '@/components/matrix/sectionDetailsBlack'
import Testimonials_03 from '@/components/matrix/testimonials_03'
import SectionAditionalInfos from '@/components/matrix/sectionAditionalInfos'
import SectionCta from '@/components/matrix/sectionCta'
import SwipperTimeline from '@/components/matrix/swipperTimeline'
import CounterSection from '@/components/matrix/counterSection'
import InisStats from '@/components/matrix/inisStats'
import ActivityReport from '@/components/matrix/activityReport'
import SectionPersonnel from '@/components/matrix/sectionPersonnel'
import PartnersLogos from '@/components/matrix/partnersLogos'
import AccordionFullWidth from '@/components/matrix/accordionFullWidth'
import ImgFullWidth from '@/components/matrix/imgFullWidth'
import InfoCardWithImage from '@/components/matrix/infoCardWithImage'
import NewsletterForm from '@/components/matrix/newsletterForm'

export default {
    name: 'matrixFields',
    components: {
        TextOneColumn,
        HeaderText,
        TextTwoColumns,
        VideoEmbed,
        Quote,
        TextImg,
        TextHighlight,
        NewsFooter,
        ImagesGallery,
        AlternatelySections,
        SectionDetailsBlack,
        Testimonials_03,
        SectionAditionalInfos,
        SectionCta,
        SwipperTimeline,
        CounterSection,
        InisStats,
        ActivityReport,
        SectionPersonnel,
        PartnersLogos,
        AccordionFullWidth,
        ImgFullWidth,
        InfoCardWithImage,
        NewsletterForm
    },
    props: {
        matrix: {
            type: Object,
            required: true,
        },
        indexMatrix:{
            type: Number,
            required: false,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
